// extracted by mini-css-extract-plugin
module.exports = {"placer":"PositionEditor_placer__36aYK","container":"PositionEditor_container__SqaQw","bg":"PositionEditor_bg__1BtMv"};